import React from "react";

interface ContainerProps {
  children: React.ReactNode;
}

const Container = ({ children }: ContainerProps) => {
  return (
    <div className="flex flex-col justify-center items-center max-w-[1240px] h-full mx-auto px-4">
      {children}
    </div>
  );
};

export default Container;
